import { ExternalLink, ExternalLinkProps } from "components/Link/ExternalLink";

export const TopbarLink: React.FC<React.PropsWithChildren<ExternalLinkProps>> =
  ({ children, ...rest }) => {
    return <ExternalLink {...rest}>{children}</ExternalLink>;
  };
